import { Field, JsonParseError, JsonParseErrorCode } from "sparkson";

export class Soundtrack {
  musicStartTime?: number;
  musicEndTime?: number;

  constructor(
    @Field("u", true) public musicUrl: string,
    @Field("s", true) public musicStart: string = "0",
    @Field("e", true) public musicEnd: string = "0"
  ) {
    this.changeMillisecondsToSeconds();
    this.validate();
  }

  private changeMillisecondsToSeconds() { 
    this.musicStartTime = Number(this.musicStart) / 1000;
    this.musicEndTime = Number(this.musicEnd) / 1000;
  }

  private validate() {

    if (!this.musicUrl || this.musicUrl === "") {
      throw new JsonParseError("musicUrl must be defined)", JsonParseErrorCode.VALIDATION_FAILED);
    }

    if (isNaN(this.musicStartTime)) {
      throw new JsonParseError("musicStartTime must be a string that can be parsed as number", JsonParseErrorCode.VALIDATION_FAILED);
    }

    if (isNaN(this.musicEndTime)) {
      throw new JsonParseError("musicEndTime must be a string that can be parsed as number", JsonParseErrorCode.VALIDATION_FAILED);
    }

    if (this.musicStartTime < 0) {
      throw new JsonParseError("musicStartTime must be greater than or equal to 0", JsonParseErrorCode.VALIDATION_FAILED);
    }

    if (this.musicEndTime < 0) {
      throw new JsonParseError("musicStartTime must be greater than or equal to 0", JsonParseErrorCode.VALIDATION_FAILED);
    }
  }

}
